export default "/images/5d81390b958eb00e1fa47d32245c23bd.avif";